


export const ObjectGategories = () => {
    return <></>
}